module.exports = __webpack_public_path__ + "public/StoreIcon/Dropdownwithcircle30x30.svg?09afc46a";